var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextHOne = function SvgIconTextHOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.25a1 1 0 0 0-2 0V16.5a1 1 0 1 0 2 0v-4.625h7.75V16.5a1 1 0 1 0 2 0V5.25a1 1 0 1 0-2 0v4.625H4.75zM21.625 10.125a1 1 0 0 0-1.555-.832l-2.25 1.5a1 1 0 0 0 1.11 1.664l.695-.464v6.757a1 1 0 1 0 2 0z"
  }))));
};
export default SvgIconTextHOne;